// src/component/APIs/RequestHandler.js

import decode from 'jwt-decode'
import axios from 'axios'

class RequestHandler {
  // axios.defaults.baseURL = 'https://api.example.com'
  // axios.defaults.headers.common['Authorization'] = AUTH_TOKEN
  // axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
  noAuthHeaders = {
    'Content-Type': 'application/json',
    Locale: 'EN'
  }

  authHeaders = {
    Authorization: `Bearer ${sessionStorage.getItem('jwtToken')}`,
    'Content-Type': 'application/json',
    Locale: 'EN'
  }
  errors = []
  test () {
    alert('hello')
  }

  generateHeader (withToken) {
    return this.generateHeaderWithContentType(withToken, null)
  }

  generateHeaderWithContentType (withToken, contentType) {
    const ct = contentType || 'application/json'
    if (withToken) {
      return {
        Authorization: `Bearer ${sessionStorage.getItem('jwtToken')}`,
        'Content-Type': ct,
        Locale: 'EN'
      }
    } else {
      return {
        'Content-Type': ct,
        Locale: 'EN'
      }
    }
  }

  generateHeader2 (withToken) {
    if (withToken) {
      return {
        Authorization: `Bearer ${sessionStorage.getItem('jwtToken')}`,
        // 'Content-Type': 'application/json',
        Locale: 'EN'
      }
    } else {
      return {
        'Content-Type': 'application/json',
        Locale: 'EN'
      }
    }
  }

  async post (url, body, withToken) {
    this.errors = []
    try {
      let postResponse = await axios.post(this.addEnvBaseURL(url), body, {
        headers: this.generateHeader(withToken)
      })
      return postResponse
    } catch (error) {
      this.errors.push(error)
    }
  }

  async put (url, body, withToken) {
    this.errors = []
    try {
      let putResponse = await axios.put(this.addEnvBaseURL(url), body, {
        headers: this.generateHeader(withToken)
      })
      return putResponse
    } catch (error) {
      this.errors.push(error)
    }
  }

  async patch (url, body, withToken) {
    this.errors = []
    try {
      let patchResponse = await axios.patch(this.addEnvBaseURL(url), body, {
        headers: this.generateHeader(withToken)
      })
      return patchResponse
    } catch (error) {
      this.errors.push(error)
    }
  }

  async get (url, withToken) {
    // this.addEnvBaseURL(url)
    if (process.env.NODE_ENV === 'fake') {
      // return 'data:[]'
      return this.getFakeResponse(url)
    }
    this.errors = []
    var myHeaders = this.noAuthHeaders
    try {
      let getResponse = await axios.get(this.addEnvBaseURL(url), {
        headers: this.generateHeader(withToken)
      })
      return getResponse
    } catch (error) {
      this.errors.push(error)
    }
  }

  async delete (url, withToken) {
    this.errors = []
    try {
      let getResponse = await axios.delete(this.addEnvBaseURL(url), {
        headers: this.generateHeader(withToken)
      })
      return getResponse
    } catch (error) {
      this.errors.push(error)
    }
  }

  async postFormData (url, formData, withToken) {
    this.errors = []
    try {
      let postResponse = await axios.post(this.addEnvBaseURL(url), formData, {
        headers: this.generateHeaderWithContentType(withToken, 'multipart/form-data')
      })
      return postResponse
    } catch (error) {
      this.errors.push(error)
    }
  }

  async getBlob (url, withToken) {
    this.errors = []
    var myHeaders = this.noAuthHeaders
    try {
      let getResponse = await axios.get(this.addEnvBaseURL(url), {
        headers: this.generateHeader2(withToken),
        responseType: 'blob'
      })
      return getResponse
    } catch (error) {
      this.errors.push(error)
    }
  }

  addEnvBaseURL (url) {
    let env = JSON.parse(sessionStorage.getItem('selectedEnv'))
    let baseURL = process.env['VUE_APP_QUBER_BASE_URL_' + env.code]
    url = baseURL + url
    return url
  }

  getFakeResponse (url) {
    return {
      data: [
        {
          type: 'information',
          id: 1,
          title: 'For Your Security...',
          description: 'your bank is requesting confirmation of your account details.',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/errors/bank_in_error.png',
          subType: null,
          userDismissible: true
        },
        {
          type: 'information',
          id: 2,
          title: 'Win $250 this week',
          description: 'by moving money into the Vault. Tap for details.',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/contests/weekly.png',
          subType: 'web',
          userDismissible: true,
          informationUrl: 'https://www.quber.ca/savetowin/#weeklywin'
        },
        {
          type: 'information',
          id: 3,
          title: 'For every $20 saved...',
          description: 'you get a chance to win $1000! Tap for details.',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/contests/grandprize.png',
          subType: 'web',
          userDismissible: true,
          informationUrl: 'https://www.quber.ca/savetowin/#grandwin'
        },
        {
          type: 'information',
          id: 4,
          title: 'Refer 3 friends',
          description: 'and you get a chance to win $250',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/contests/referafriend.png',
          subType: 'inapp',
          userDismissible: true,
          informationUrl: 'refer-a-friend'
        },
        {
          type: 'information',
          id: 5,
          title: 'Your opinion matters...',
          description: 'Take our survey for a chance to win $50 towards your saving jar!',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/contests/survey.png',
          subType: null,
          userDismissible: true,
          informationUrl: 'https://www.surveymonkey.com/r/6Y83XFW'
        },
        {
          type: 'information',
          id: 6,
          title: 'Trick or Treat!',
          description: 'Save {0,number,currency} in your {1} jar today.',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/recommendation/rule/halloween-recommendation.png',
          subType: null,
          userDismissible: true
        },
        {
          type: 'information',
          id: 7,
          title: 'Give yourself {0,number,currency}',
          description: 'towards your {1} jar because you score an extra hour of sleep this weekend!',
          imageUrl:
            'https://quberimages-prod.s3.amazonaws.com/cards/recommendation/rule/daylightsavings-recommendation.png',
          subType: null,
          userDismissible: true
        },
        {
          type: 'information',
          id: 8,
          title: 'Pack a lunch this week',
          description: 'and save {0,number,currency} towards your {1} jar.',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/recommendation/rule/pack-lunch.png',
          subType: null,
          userDismissible: true,
          informationUrl: 'https://www.quber.ca/faq/#TaptoSaveTab'
        },
        {
          type: 'information',
          id: 9,
          title: 'Happy Diwali 2018',
          description: 'Celebrate the festival of lights by saving {0,number,currency} in your {1} jar.',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/recommendation/rule/dilawi.png',
          subType: null,
          userDismissible: true
        },
        {
          type: 'information',
          id: 10,
          title: 'Go Ahead, Reward Yourself.',
          description: 'Save {0,number,currency} in your {1} jar today.',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/recommendation/rule/its-friday.png',
          subType: null,
          userDismissible: true
        },
        {
          type: 'information',
          id: 11,
          title: 'Go Ahead, Reward Yourself.',
          description: 'Save {0,number,currency} in your {1} jar today.',
          imageUrl: 'https://quberimages.s3.amazonaws.com/cards/recommendation/rule/its-friday.png',
          subType: null,
          userDismissible: true
        },
        {
          type: 'information',
          id: 12,
          title: 'COFFEE CHALLENGE!',
          description: 'Make your own and tap to save {0,number,currency} in your {1} jar.',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/recommendation/rule/coffee.png',
          subType: null,
          userDismissible: true,
          informationUrl: 'https://www.quber.ca/faq/#TaptoSaveTab'
        },
        {
          type: 'information',
          id: 13,
          title: 'Kids can save too!',
          description: 'Create a special jar just for your child and teach them the value of money.',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/recommendation/jar/kidsday.png',
          subType: null,
          userDismissible: true,
          informationUrl: 'https://www.quber.ca/faq/#TaptoSaveTab'
        },
        {
          type: 'information',
          id: 14,
          title: 'Invest in rest',
          description: 'Save {0,number,currency} in your {1} jar if you got 7+ hours of sleep last night!',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/recommendation/rule/sleepy-dog.png',
          subType: null,
          userDismissible: true,
          informationUrl: 'https://www.quber.ca/faq/#TaptoSaveTab'
        },
        {
          type: 'information',
          id: 15,
          title: 'Packed your lunch?',
          description: 'Tap to save {0,number,currency} in your {1} jar',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/recommendation/rule/pack-lunch.png',
          subType: null,
          userDismissible: true,
          informationUrl: 'https://www.quber.ca/faq/#TaptoSaveTab'
        },
        {
          type: 'information',
          id: 16,
          title: 'Giving sure feels good!',
          description: 'Celebrate National Day of Giving with a new donations jar.',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/recommendation/jar/charity-jar.png',
          subType: null,
          userDismissible: true
        },
        {
          type: 'information',
          id: 17,
          title: 'Enjoying a snow day?',
          description: 'Tap to save {0,number,currency} in your {1} jar',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/recommendation/rule/snowman.png',
          subType: null,
          userDismissible: true,
          informationUrl: 'https://www.quber.ca/faq/#TaptoSaveTab'
        },
        {
          type: 'information',
          id: 18,
          title: 'Support local business?',
          description: 'Tap to save {0,number,currency} in your {1} jar',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/recommendation/rule/shoplocal.png',
          subType: null,
          userDismissible: true,
          informationUrl: 'https://www.quber.ca/faq/#TaptoSaveTab'
        },
        {
          type: 'information',
          id: 19,
          title: 'Enjoy a winter activity?',
          description: 'Tap to save {0,number,currency} in your {1} jar',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/recommendation/rule/snowman.png',
          subType: null,
          userDismissible: true,
          informationUrl: 'https://www.quber.ca/faq/#TaptoSaveTab'
        },
        {
          type: 'information',
          id: 20,
          title: 'Have an idea?!',
          description: 'Tell us what would motivate you to save more money.',
          imageUrl: 'https://s3.ca-central-1.amazonaws.com/quberimages-prod/cards/contests/taptosave.png',
          subType: 'web',
          userDismissible: true,
          informationUrl:
            'mailto:emily.ward@quber.ca?subject=Tap%20to%20save%20entry&body=What%20motivates%20you%20to%20save?%20Is%20it%20walking%20your%20dog?%20Finishing%20a%20workout?%20Wearing%20the%20ugliest%20xmas%20sweater%20to%20a%20party?%20We%20want%20to%20hear%20your%20ideas%21%20%0A%0AYour%20Tap%20to%20Save%20idea:%0A%0AIf%20you%20have%20a%20photo%20to%20go%20with%20your%20idea,%20attach%20it.%20It%20may%20be%20displayed%20on%20your%20Tap%20to%20Save%20card%21%0A%0AContest%20ends%20Dec%2021,%202018.%20The%20QUBER%20team%20will%20vote%20on%20their%20favorite%20and%20the%20winner%20will%20choose%20a%20registered%20charity%20that%20QUBER%20will%20donate%20$100%20to%20on%20their%20behalf.%0A%0AIf%20you%20use%20iOS,%20tap%20and%20hold%20to%20Insert%20Photo'
        },
        {
          type: 'information',
          id: 21,
          title: 'Completed a workout?',
          description: 'Why not reward yourself! Tap to save {0,number,currency} in your {1} jar.',
          imageUrl: 'https://s3.ca-central-1.amazonaws.com/quberimages-prod/cards/recommendation/rule/workout.png',
          subType: null,
          userDismissible: true,
          informationUrl: 'https://www.quber.ca/faq/#TaptoSaveTab'
        },
        {
          type: 'information',
          id: 22,
          title: 'Feeling festive?',
          description: 'Tap to save {0,number,currency} in your jar if you wore the ugliest sweater to the party!',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/recommendation/rule/uglyxmassweater.png',
          subType: null,
          userDismissible: true
        },
        {
          type: 'information',
          id: 23,
          title: 'Get cashback rewards!',
          description: 'Spend and save at participating merchants - tap to find out more.',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/cashback/spendandsaverewards.png',
          subType: null,
          userDismissible: false,
          informationUrl: 'https://www.quber.ca/faq/#RewardsTab'
        },
        {
          type: 'information',
          id: 24,
          title: 'Happy winter solstice!',
          description: 'Tap to save {0,number,currency} in your {1} jar',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/recommendation/rule/sunny.png',
          subType: null,
          userDismissible: true
        },
        {
          type: 'information',
          id: 25,
          title: 'Merry Christmas to you!',
          description: 'Tap to save {0,number,currency} in your {1} jar',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/recommendation/rule/christmas.png',
          subType: null,
          userDismissible: true
        },
        {
          type: 'information',
          id: 26,
          title: 'Cheers to a new year!',
          description: 'Tap to save {0,number,currency} in your {1} jar',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/recommendation/rule/newyears.png',
          subType: null,
          userDismissible: true
        },
        {
          type: 'information',
          id: 27,
          title: 'We challenge you!',
          description: 'Go a day with no social media and tap to save {0,number,currency}',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/recommendation/rule/socialmedia.png',
          subType: null,
          userDismissible: true,
          informationUrl: 'https://www.quber.ca/faq/#TaptoSaveTab'
        },
        {
          type: 'information',
          id: 28,
          title: 'Fill out this short survey',
          description: 'for a chance to win $25 towards your saving goal!',
          imageUrl: 'https://s3.ca-central-1.amazonaws.com/quberimages-prod/cards/contests/survey.png',
          subType: null,
          userDismissible: true,
          informationUrl: 'https://www.surveymonkey.com/r/PBD97BM'
        },
        {
          type: 'information',
          id: 29,
          title: 'Rocked a no spend day?',
          description: 'Tap to save {0,number,currency} in your {1} jar',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/recommendation/rule/no-spend-day.png',
          subType: null,
          userDismissible: true,
          informationUrl: 'https://www.quber.ca/faq/#TaptoSaveTab'
        },
        {
          type: 'information',
          id: 30,
          title: 'Broken screen?',
          description: 'Fix it today! Visit the CaseDepot CPR Moncton and earn 2.5% cashback towards your Quber jar!',
          imageUrl: 'https://s3.ca-central-1.amazonaws.com/quberimages-prod/cards/cashback/casedepotlogo2.png',
          subType: null,
          userDismissible: true,
          informationUrl: 'https://www.quber.ca/faq/#RewardsTab'
        },
        {
          type: 'information',
          id: 31,
          title: 'Give yourself some love',
          description: 'Tap to save {0,number,currency} in your {1} jar.',
          imageUrl: 'https://s3.ca-central-1.amazonaws.com/quberimages-prod/cards/recommendation/rule/valentine.png',
          subType: null,
          userDismissible: true,
          informationUrl: 'https://www.quber.ca/faq/#TaptoSaveTab'
        },
        {
          type: 'information',
          id: 32,
          title: 'Time to file taxes?',
          description: 'Get a discount + cashback in your jar.  Tap here to get started!',
          imageUrl: 'https://s3.ca-central-1.amazonaws.com/quberimages-prod/cards/cashback/turbo-tax.png',
          subType: 'web',
          userDismissible: true,
          informationUrl:
            'https://turbotax.intuit.ca/x/affiliates/index.jsp?brandID=affiliate15&priorityCode=9531-00000&cid=aff_fy19&src=aff&PID=9006496&ADID=13607907&cjevent=e6e34faa384411e9815e018c0a240610'
        },
        {
          type: 'information',
          id: 33,
          title: 'Celebrate the women in your life.',
          description: 'Tap to save {0,number,currency} in your {1} jar.',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/recommendation/rule/womensday.png',
          subType: null,
          userDismissible: true,
          informationUrl: 'https://www.quber.ca/faq/#TaptoSaveTab'
        },
        {
          type: 'information',
          id: 34,
          title: 'Easter bunny find you?',
          description: 'Tap to save {0,number,currency} in your {1} jar',
          imageUrl: 'https://quberimages-prod.s3.amazonaws.com/cards/recommendation/rule/easter.png',
          subType: null,
          userDismissible: true,
          informationUrl: 'https://www.quber.ca/faq/#TaptoSaveTab'
        },
        {
          type: 'information',
          id: 36,
          title: 'Hydration is important!',
          description: 'Tap to save {0,number,currency} in your {1} jar if you drank enough water today.',
          imageUrl: 'https://s3.ca-central-1.amazonaws.com/quberimages/cards/recommendation/rule/glassofwater.png',
          subType: null,
          userDismissible: true,
          informationUrl: 'https://www.quber.ca/faq/#TaptoSaveTab'
        },
        {
          type: 'information',
          id: 37,
          title: 'Time for a break?',
          description: 'Go for a light walk. Tap to save {0,number,currency} in your {1} jar.',
          imageUrl: 'https://s3.ca-central-1.amazonaws.com/quberimages/cards/recommendation/rule/walkingdog.png',
          subType: null,
          userDismissible: true,
          informationUrl: 'https://www.quber.ca/faq/#TaptoSaveTab'
        },
        {
          type: 'information',
          id: 38,
          title: 'Choose healthy!',
          description: 'Made a better nutrition choice? Tap to save {0,number,currency} in your {1} jar.',
          imageUrl: 'https://s3.ca-central-1.amazonaws.com/quberimages/cards/recommendation/rule/healthylunch.png',
          subType: null,
          userDismissible: true,
          informationUrl: 'https://www.quber.ca/faq/#TaptoSaveTab'
        },
        {
          type: 'information',
          id: 39,
          title: 'Get active!',
          description: 'Do 30 mins of activity and tap to save {0,number,currency} in your {1} jar.',
          imageUrl: 'https://s3.ca-central-1.amazonaws.com/quberimages/cards/recommendation/rule/physicalactivity.png',
          subType: null,
          userDismissible: true,
          informationUrl: 'https://www.quber.ca/faq/#TaptoSaveTab'
        },
        {
          type: 'information',
          id: 40,
          title: 'Tap to save $10...',
          description: 'if you remembered your mom today!',
          imageUrl: 'https://s3.ca-central-1.amazonaws.com/quberimages/cards/recommendation/rule/mothersday2019.png',
          subType: null,
          userDismissible: true
        }
      ]
    }
  }
}

export default new RequestHandler()
